import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getAccessToken } from '../utils/auth';

function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [queryParams, setQueryParams] = useState({ client_id: '', state: '' });

  useEffect(() => {
    const checkToken = async () => {
      const token = await getAccessToken();
      if (!token) {
        // Clear any existing token cookie and local storage if token is invalid
        console.log("Login: No valid token found, clearing cookies and local storage");
        // document.cookie = 'access-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'access-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + process.env.REACT_APP_UI_DOMAIN + ";";
        localStorage.removeItem('chatThread');
        localStorage.removeItem('messagesFetched');
      }
    };
    checkToken();
    
    // Extract query parameters
    const clientId = searchParams.get('client_id');
    const state = searchParams.get('state');
    const client_type = searchParams.get('client');
    console.log("Login: Extracted query params - client_id: ", clientId, ", state: ", state, ", client: ", client_type);
    setQueryParams({ 
      client_id: clientId || '', 
      state: state || '',
      client: client_type || ''
    });
  }, [searchParams]);

  const handleLogin = async (idp) => {
    try {
      // let url = `${process.env.REACT_APP_ORCHESTRATOR_AUTHORIZATION_SERVER}/auth/login/${idp}?client=react`;
      let url = `${process.env.REACT_APP_ORCHESTRATOR_AUTHORIZATION_SERVER}/auth/login/${idp}`;
      if (queryParams.client) url += `?client=${queryParams.client}`; else url += `?client=react`;
      if (queryParams.client_id) url += `&client_id=${queryParams.client_id}`;
      if (queryParams.state) url += `&state=${queryParams.state}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
      });

      console.log("Response type is --> "+response.type)

      if (response.ok) {
        const redirectUrl = await response.text()
        console.log("Redirecting user to: "+redirectUrl.replaceAll('"', ''))
        window.location.href = redirectUrl.replaceAll('"', '');
      } else {
        console.log("Login API: "+process.env.REACT_APP_ORCHESTRATOR_AUTHORIZATION_SERVER+"/auth/login/"+idp);
        console.log("Unable to redirect to authorization endpoint - Returned status: "+response.status)
        navigate('/register');
      }
    } catch (error) {
      console.error('Error during login:', error);
      navigate('/register');
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <img src="./media/applucent-logo.jpeg" alt="Applucent" className="login-logo" />
        <p>Please login to continue</p>
        <div className="login-buttons">
          <button onClick={() => handleLogin('google')} className="login-button">
            <img src="./media/google-logo-123.svg" alt="Logo" className="logo" />Login with Google
          </button>
          <button onClick={() => handleLogin('microsoft')} className="login-button">
            <img src="./media/microsoft-logo-123.svg" alt="Logo" className="logo" />Login with Microsoft
            
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;